module.exports = __webpack_public_path__ + "static/media/IMG_8884.74db1634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8884.jpg
// module id = 158
// module chunks = 0